export const LOGIN_TYPE = {
  FB: '0',
  GOOGLE: '1',
  FUNLIDAY: '2',
  APPLE: '3',
  YAHOO: '4',
  GUEST: '5',
  TWITTER: '6',
  LETSGOJP: '7'
};

export const LOGIN_TYPE_NAME = {
  [LOGIN_TYPE.FB]: 'Facebook',
  [LOGIN_TYPE.GOOGLE]: 'Google',
  [LOGIN_TYPE.APPLE]: 'Apple',
  [LOGIN_TYPE.YAHOO]: 'Yahoo',
  [LOGIN_TYPE.TWITTER]: 'Twitter'
};

const CONFIG = {
  // facebook app only allow one url
  // using different app for production and development
  FACEBOOK: {
    ID: process.env.REACT_APP_FB_LOGIN_ID,
    LOGIN_TYPE: LOGIN_TYPE.FB
  },

  // using different app for production and development
  // prod project : funliday(ethereal-tract-801)
  // dev project : funliday-dev(extreme-tooling-669)
  GOOGLE: {
    ID: process.env.REACT_APP_GOOGLE_LOGIN_ID,
    LOGIN_TYPE: LOGIN_TYPE.GOOGLE,
    API: 'https://apis.google.com/js/api.js'
  },

  APPLE: {
    ID: process.env.REACT_APP_APPLE_LOGIN_ID,
    LOGIN_TYPE: LOGIN_TYPE.APPLE,
    REDIRECT_URI:
      process.env.REACT_APP_NODE_ENV === 'local'
        ? 'https://funliday-web-dev.herokuapp.com/login'
        : `${process.env.REACT_APP_WEB_DOMAIN}/login`
  },

  YAHOO: {
    ID: process.env.REACT_APP_YAHOO_LOGIN_ID,
    LOGIN_TYPE: LOGIN_TYPE.YAHOO,
    REDIRECT_URI:
      process.env.REACT_APP_NODE_ENV === 'local'
        ? 'https://localhost:2000/oauth/callback/yahoo'
        : `${process.env.REACT_APP_WEB_DOMAIN}/oauth/callback/yahoo`
  },

  LETSGOJP: {
    ID: process.env.REACT_APP_LETSGOJP_LOGIN_ID,
    LOGIN_TYPE: LOGIN_TYPE.LETSGOJP
  },

  LOGIN_URL:
    process.env.REACT_APP_NODE_ENV === 'local'
      ? 'http://localhost:2000/login'
      : `${process.env.REACT_APP_WEB_DOMAIN}/login`
};

export const OAUTH_PROVIDER = {
  TWITTER: 'twitter',
  YAHOO: 'yahoo',
  APPLE: 'apple',
  GOOGLE_ONE_TAP: 'google-one-tap'
};

export const FIRST_LOGIN_ACTION = {
  GET_STARTED: 1,
  SKIP: 2
};

export const UPDATE_LOGIN_ERROR = {
  ALREADY_REGISTERED: '800',
  INVALID_REFERRAL_CODE: '801'
};

export default CONFIG;
